import { Typography } from '@mui/material';
import { CURRENCIES, type Currency } from '@vy/types';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { VySelect } from '../../../../components/new-design/atoms';

type CurrencyOverrideSelectProps<FormFields extends FieldValues> = {
  control: Control<FormFields>;
  name: Path<FormFields>;
  placeholder?: string;
  defaultValue?: Currency;
};

export const CurrencyOverrideSelect = <FormFields extends FieldValues>({
  control,
  name,
  placeholder = 'Customer default',
  defaultValue,
}: CurrencyOverrideSelectProps<FormFields>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const DEFAULT_KEY = '__DEFAULT__';
        const currencyEntries = Object.values(CURRENCIES) as Currency[];
        const options = [{ key: DEFAULT_KEY }, ...currencyEntries.map((c) => ({ key: c }))];
        const selectedOption = { key: getSelectedCurrency(field.value, defaultValue, DEFAULT_KEY) };

        return (
          <VySelect
            label=""
            placeholder={placeholder}
            options={options}
            fullWidth
            selectProps={{
              sx: {
                paddingLeft: '12px',
                height: '40px !important',
              },
            }}
            selectedOption={selectedOption}
            keyExtractor={(o) => String(o.key)}
            render={(o) => <Typography>{o.key === DEFAULT_KEY ? placeholder : (o.key as string)}</Typography>}
            onSelectionChange={(selected) => {
              const key = (selected?.key as string | undefined) ?? DEFAULT_KEY;
              field.onChange(key === DEFAULT_KEY ? undefined : (key as Currency));
            }}
          />
        );
      }}
    />
  );
};

function getSelectedCurrency(
  fieldValue: Currency | undefined,
  defaultValue: Currency | undefined,
  defaultKey: string,
) {
  if (fieldValue) {
    return fieldValue;
  }

  if (defaultValue) {
    return defaultValue;
  }

  return defaultKey;
}
